import React from 'react';

const SvgBolt: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.823 11.575l-6.011 8.683c-.551.795-1.798.406-1.798-.562v-5.723H5.989a.987.987 0 01-.811-1.549l6.011-8.683c.551-.795 1.798-.406 1.798.562v5.723h5.025a.987.987 0 01.811 1.549z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgBolt;
